import theme from '../../theme';
import { styled } from '@mui/material/styles';
import Checkbox from '@mui/material/Checkbox';

export const CheckboxStyle = styled(Checkbox)(({ media }) => {
  let mainColor;
  if (media === 'FACEBOOK') {
    mainColor = theme.palette.facebook.main;
  } else if (media === 'GOOGLE') {
    mainColor = theme.palette.google.main;
  } else {
    mainColor = theme.palette.line.main;
  }

  return {
    color: mainColor,
    '&.Mui-checked': {
      color: mainColor,
    },
  }
})

export const CheckboxBlueMain = styled(Checkbox)(({ theme }) => ({
  color: theme.palette.facebook.main,
  '&.Mui-checked': {
    color: theme.palette.facebook.main,
  },
}))

export const CheckboxOrangeMain = styled(Checkbox)(({ theme }) => ({
  color: theme.palette.google.main,
  '&.Mui-checked': {
    color: theme.palette.google.main,
  },
}))

export const CheckboxGreenMain = styled(Checkbox)(({ theme }) => ({
  color: theme.palette.line.main,
  '&.Mui-checked': {
    color: theme.palette.line.main,
  },
}))